import { useEffect, useState } from 'react';

import { CHALLENGE_PAYMENT_RESULT_TYPE } from '../../../constants/challengePaymentResultType';
import { getPaymentResultParams } from '../../../utils/getPaymentResultParams';
import { ChallengePaymentResult } from '../../../interfaces/paymentResult';
import { paymentResultService } from '../../../services/paymentResultService';

type UseChallengePaymentResultReturn = {
  paymentInfo: ChallengePaymentResult | null;
  isSuccess: boolean;
  retryPath: string;
};

export const useChallengePaymentResult = (): UseChallengePaymentResultReturn => {
  const [paymentInfo, setPaymentInfo] = useState<ChallengePaymentResult | null>(null);

  const params = getPaymentResultParams();

  const {
    participantId,
    redirectStatus,
    paymentResultType,
    retryPath,
    paymentIntentId,
    connectedAccountId,
  } = params;

  const isSuccess = redirectStatus === 'succeeded';

  const getPaymentInfo = async () => {
    switch (paymentResultType) {
      case CHALLENGE_PAYMENT_RESULT_TYPE.FREE: {
        const result =
          await paymentResultService.getChallengeFreePaymentDetails(participantId);
        setPaymentInfo(result);
        return;
      }
      case CHALLENGE_PAYMENT_RESULT_TYPE.WITH_PAYMENT: {
        const result = await paymentResultService.getChallengePaymentDetails(
          participantId,
          paymentIntentId,
          connectedAccountId,
        );
        setPaymentInfo(result);
        return;
      }
      default:
        return;
    }
  };

  useEffect(() => {
    getPaymentInfo();
  }, [paymentResultType]);

  return {
    paymentInfo,
    isSuccess,
    retryPath,
  };
};
